import { makeStyles } from 'tss-react/mui';
import { alpha, Theme } from '@mui/material';

export

const useStyles = makeStyles()(() => ({
 
  tableCell: {
    width: 'auto',
    textTransform: 'none',
    boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
    marginLeft: 0,
    padding: '6px 20px',
    paddingRight: '10px',
    fontSize: 16,
    fontWeight: 500,
    backgroundColor: '#fff',
    color: '#575655',
    height: 40,
    borderBottom: '1px solid #c4c4c4',
    // Make sure the icon is visible
    '& .MuiTableSortLabel-icon': {
      opacity: '1 !important',  // Force visibility of the icon
      color: '#c4c4c4',         // Optional: set a color for the icon
    },
    "& .MuiTableSortLabel-root:hover, .MuiTableSortLabel-root:hover .MuiTableSortLabel-icon": {
      color: "#000"
    },
    "& .MuiTableSortLabel-root.Mui-active:hover, .MuiTableSortLabel-root.Mui-active:hover .MuiTableSortLabel-icon": {
      color: "#000"
    },
    "& .MuiTableSortLabel-root.Mui-active, .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon": {
      fontWeight: 600,
      color: "#d30535",
    }
  },
}));
